"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("./Input"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var NumInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "NumberInput__NumInput",
  componentId: "sc-1fukdvc-0"
})(["::-webkit-inner-spin-button,::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:textfield;appearance:none;}"]);
var NumberInput = function NumberInput(_ref) {
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    innerRef = _ref.innerRef,
    pattern = _ref.pattern,
    step = _ref.step,
    rest = _objectWithoutProperties(_ref, ["name", "value", "onChange", "disabled", "innerRef", "pattern", "step"]);
  var validateChange = function validateChange(event) {
    if (event.target.value.length === 0 || event.target.validity.valid) {
      onChange(event.target.value);
    }
  };
  var validateOnBlur = function validateOnBlur(event) {
    var val = event.target.value;
    if (val == null || val.trim() === "" || !event.target.validity.valid) {
      onChange(val);
    }
  };
  return _react["default"].createElement(NumInput, _extends({
    id: name,
    type: "number",
    pattern: pattern,
    onChange: validateChange,
    onBlur: validateOnBlur,
    value: value,
    disabled: disabled,
    ref: innerRef,
    step: step
  }, rest));
};
NumberInput.propTypes = {
  /** id property of the input field */
  name: _propTypes["default"].string,
  /** pattern of the input field to follow */
  pattern: _propTypes["default"].string,
  /** step of the input field to follow */
  step: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /** property where the value of the input field will be stored */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /** function to be called when the input value is changed */
  onChange: _propTypes["default"].func.isRequired,
  /** flag to disable/enable the input field */
  disabled: _propTypes["default"].bool,
  /**  reference to the number input */
  innerRef: _propTypes["default"].any
};
NumberInput.defaultProps = {
  name: "best-number-input",
  pattern: "[-+]?[0-9]*[.,]?[0-9]+",
  step: "",
  disabled: false,
  innerRef: null,
  value: null
};
var _default = NumberInput;
exports["default"] = _default;